import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VCurrencyField from 'v-currency-field'
import moment from 'moment';
import { VueMaskDirective } from 'v-mask'

Vue.config.productionTip = false

Vue.directive('mask', VueMaskDirective);

Vue.use(VCurrencyField, { 
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: null,
  valueAsInteger: false,
  allowNegative: true
})

Vue.filter('booleanToText', function (value) {
  return value ? 'Sim' : 'Não';
})

Vue.filter('formatDate', function (value) {
  if (!value)
    return value;
  return moment(value).format('DD/MM/YYYY');
})

Vue.filter('formatDecimal', function (value, decimals=null) {
  if (!value)
    return value;

  if (decimals) 
    return value.toLocaleString('pt-BR', { minimumFractionDigits: decimals });

  return value.toLocaleString('pt-BR');
})

Vue.filter('formatZipcode', function (value) {
  return value ? value.replace(/\D/g,"").replace(/^(\d\d)(\d\d\d)(\d\d)/g,"$1.$2-$3") : null;
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
